import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "mobx-react";
import Store from "./Store";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { LoadingPage } from "./Page/Loading";
import axiosInstance from "./services/axiosInstance";
import commonStore from "./Store/marco/commonStore";

const root = ReactDOM.createRoot(document.getElementById("root"));

// 統一渲染主要 App 的函式
function renderApp() {
  root.render(
    <CookiesProvider>
      <BrowserRouter>
        <Provider store={Store}>
          <React.Suspense fallback={<LoadingPage />}>
            <App />
          </React.Suspense>
        </Provider>
      </BrowserRouter>
    </CookiesProvider>
  );
}

// 初始顯示 LoadingPage
root.render(
  <React.StrictMode>
    <LoadingPage />
  </React.StrictMode>
);

// 在啟動時取得版本號
async function initializeVersion() {
  try {
    const response = await axiosInstance.get("/api/system/version", {
      skipAuth: true,
    });
    const version = response.data.data;
    if (version) {
      commonStore._handleSetVersion(version);
    }
  } catch (error) {
    console.error("Error fetching version:", error);
  } finally {
    // 無論成功或失敗，統一渲染 App
    renderApp();
  }
}

initializeVersion();
